import axios from '@/common/axios'
import { useMlapProjectStore } from '@/stores/mlapProject'

const PROJECTS_URL = '/mlap/ajax/projects'

export function fetchProjects(params = {}) {
  return axios.get(PROJECTS_URL, { params })
}

export function getProject(id) {
  return axios.get(`${PROJECTS_URL}/${id}`)
}

export function createProject(data) {
  return axios.post(PROJECTS_URL, data)
}

export function updateProject(id, data) {
  return axios.patch(`${PROJECTS_URL}/${id}`, data)
}

export function getProjectBusinesses(params = {}) {
  const store = useMlapProjectStore()
  return axios.get(`${store.ajaxPrefix}/businesses`, { params })
}

// Feature-level bootstrap for the router pages (ROUTER.md §3 step 5).
export function fetchPageMeta() {
  return axios.get('/mlap/ajax/page_meta')
}

// GET twins of the project pages' styxie payloads, for client-side navigation.
export function getProjectDashboard(projectId) {
  return axios.get(`${PROJECTS_URL}/${projectId}/dashboard`)
}

export function getProjectLocation(projectId, locationId) {
  return axios.get(`${PROJECTS_URL}/${projectId}/locations/${locationId}`)
}
